export default __webpack_public_path__ + "static/media/drhouse_complex.ef540b37.png";